export default __webpack_public_path__ + "static/media/bodycard4.3c047945.png";